import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image/morentouxiang.png'
import _imports_1 from '@/assets/icon/geren.png'
import _imports_2 from '@/assets/icon/qiye.png'
import _imports_3 from '@/assets/icon/weirenzheng.png'
import _imports_4 from '@/assets/image/homeclb.png'
import _imports_5 from '../../assets/image/我的订单.png'
import _imports_6 from '../../assets/image/作品管理.png'
import _imports_7 from '../../assets/image/我的账户.png'
import _imports_8 from '../../assets/image/我的收藏.png'
import _imports_9 from '../../assets/image/我的足迹.png'
import _imports_10 from '../../assets/image/使用指南.png'
import _imports_11 from '../../assets/image/标题元素.png'
import _imports_12 from '../../assets/image/图-1.png'
import _imports_13 from '../../assets/image/跳转箭头.png'
import _imports_14 from '../../assets/image/图-2.png'
import _imports_15 from '../../assets/image/图-3.png'
import _imports_16 from '../../assets/image/图纸1.png'
import _imports_17 from '../../assets/image/图纸02.png'
import _imports_18 from '../../assets/image/切图01_03.jpg'
import _imports_19 from '../../assets/image/图-4.png'
import _imports_20 from '../../assets/image/黄色元素.png'
import _imports_21 from '../../assets/image/黄色元素02.png'
import _imports_22 from '../../assets/image/图标001.png'
import _imports_23 from '../../assets/image/图标-002.png'
import _imports_24 from '../../assets/image/图标-003.png'
import _imports_25 from '../../assets/image/图标-004.png'
import _imports_26 from '../../assets/image//紫色元素.png'
import _imports_27 from '../../assets/image//紫色元素02.png'
import _imports_28 from '../../assets/image/工业产业链-01.png'
import _imports_29 from '../../assets/image/供应链02.png'
import _imports_30 from '../../assets/image/供应链03.png'


const _withScopeId = n => (_pushScopeId("data-v-71897679"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "Rotation" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "container tankuang"
}
const _hoisted_6 = {
  class: "left",
  style: {"outline":"none"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "自动化设计方案", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "one-img",
  src: "https://image.sjyuan.net.cn/img/sjy/share/indextz.png"
}, null, -1))
const _hoisted_9 = { class: "second" }
const _hoisted_10 = { class: "onemenu" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "list" }
const _hoisted_13 = { class: "text" }
const _hoisted_14 = { class: "list" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "list" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = { class: "list" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "list" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = { class: "list" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "list" }
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "list" }
const _hoisted_27 = { class: "text" }
const _hoisted_28 = { class: "list" }
const _hoisted_29 = { class: "text" }
const _hoisted_30 = { class: "list" }
const _hoisted_31 = { class: "text" }
const _hoisted_32 = { class: "list" }
const _hoisted_33 = { class: "text" }
const _hoisted_34 = { class: "list" }
const _hoisted_35 = { class: "text" }
const _hoisted_36 = { class: "list" }
const _hoisted_37 = { class: "text" }
const _hoisted_38 = { class: "list" }
const _hoisted_39 = { class: "text" }
const _hoisted_40 = { class: "list" }
const _hoisted_41 = { class: "text" }
const _hoisted_42 = { class: "list" }
const _hoisted_43 = { class: "text" }
const _hoisted_44 = { class: "list" }
const _hoisted_45 = { class: "text" }
const _hoisted_46 = { class: "list" }
const _hoisted_47 = { class: "text" }
const _hoisted_48 = { class: "list" }
const _hoisted_49 = { class: "text" }
const _hoisted_50 = { class: "list" }
const _hoisted_51 = { class: "text" }
const _hoisted_52 = { class: "list" }
const _hoisted_53 = { class: "text" }
const _hoisted_54 = { class: "list" }
const _hoisted_55 = { class: "text" }
const _hoisted_56 = { class: "list" }
const _hoisted_57 = { class: "text" }
const _hoisted_58 = { class: "list" }
const _hoisted_59 = { class: "text" }
const _hoisted_60 = { class: "list" }
const _hoisted_61 = { class: "text" }
const _hoisted_62 = { class: "list" }
const _hoisted_63 = { class: "text" }
const _hoisted_64 = { class: "list" }
const _hoisted_65 = { class: "text" }
const _hoisted_66 = { class: "list" }
const _hoisted_67 = { class: "text" }
const _hoisted_68 = { class: "list" }
const _hoisted_69 = { class: "text" }
const _hoisted_70 = { class: "list" }
const _hoisted_71 = { class: "text" }
const _hoisted_72 = { class: "list" }
const _hoisted_73 = { class: "text" }
const _hoisted_74 = { class: "list" }
const _hoisted_75 = { class: "text" }
const _hoisted_76 = { class: "list" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "机械原理动画", -1))
const _hoisted_78 = { class: "second" }
const _hoisted_79 = { class: "onemenu2" }
const _hoisted_80 = { class: "text" }
const _hoisted_81 = { class: "list" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "自动化知识学习区", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "one-img",
  src: "https://image.sjyuan.net.cn/img/sjy/share/indextz.png"
}, null, -1))
const _hoisted_84 = { class: "second" }
const _hoisted_85 = { class: "onemenu3" }
const _hoisted_86 = { class: "text" }
const _hoisted_87 = { class: "list" }
const _hoisted_88 = { class: "text" }
const _hoisted_89 = { class: "list" }
const _hoisted_90 = { class: "text" }
const _hoisted_91 = { class: "list" }
const _hoisted_92 = { class: "text" }
const _hoisted_93 = { class: "list" }
const _hoisted_94 = { class: "text" }
const _hoisted_95 = { class: "list" }
const _hoisted_96 = { class: "text" }
const _hoisted_97 = { class: "list" }
const _hoisted_98 = { class: "text" }
const _hoisted_99 = { class: "list" }
const _hoisted_100 = { class: "text" }
const _hoisted_101 = { class: "list" }
const _hoisted_102 = { class: "text" }
const _hoisted_103 = { class: "list" }
const _hoisted_104 = { class: "text" }
const _hoisted_105 = { class: "list" }
const _hoisted_106 = { class: "text" }
const _hoisted_107 = { class: "list" }
const _hoisted_108 = { class: "text" }
const _hoisted_109 = { class: "list" }
const _hoisted_110 = { class: "text" }
const _hoisted_111 = { class: "list" }
const _hoisted_112 = { class: "text" }
const _hoisted_113 = { class: "list" }
const _hoisted_114 = { class: "text" }
const _hoisted_115 = { class: "list" }
const _hoisted_116 = { class: "text" }
const _hoisted_117 = { class: "list" }
const _hoisted_118 = { class: "text" }
const _hoisted_119 = { class: "list" }
const _hoisted_120 = { class: "text" }
const _hoisted_121 = { class: "list" }
const _hoisted_122 = { class: "text" }
const _hoisted_123 = { class: "list" }
const _hoisted_124 = { class: "text" }
const _hoisted_125 = { class: "list" }
const _hoisted_126 = { class: "text" }
const _hoisted_127 = { class: "list" }
const _hoisted_128 = { class: "text" }
const _hoisted_129 = { class: "list" }
const _hoisted_130 = { class: "text" }
const _hoisted_131 = { class: "list" }
const _hoisted_132 = { class: "text" }
const _hoisted_133 = { class: "list" }
const _hoisted_134 = { class: "text" }
const _hoisted_135 = { class: "list" }
const _hoisted_136 = { class: "text" }
const _hoisted_137 = { class: "list" }
const _hoisted_138 = { class: "text" }
const _hoisted_139 = { class: "list" }
const _hoisted_140 = { class: "text" }
const _hoisted_141 = { class: "list" }
const _hoisted_142 = { class: "text" }
const _hoisted_143 = { class: "list" }
const _hoisted_144 = { class: "text" }
const _hoisted_145 = { class: "list" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "减速机", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电动机和控制器", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "工业机器人", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "气动和液压", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "控制系统", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "机器视觉系统", -1))
const _hoisted_152 = [
  _hoisted_146,
  _hoisted_147,
  _hoisted_148,
  _hoisted_149,
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = { class: "onemenu4" }
const _hoisted_154 = { class: "text" }
const _hoisted_155 = ["onClick"]
const _hoisted_156 = { class: "list" }
const _hoisted_157 = ["onClick"]
const _hoisted_158 = { class: "right" }
const _hoisted_159 = {
  key: 0,
  class: "one"
}
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "welcome" }, "Hi, 欢迎来到设纪元", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login" }, "登录", -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register" }, "注册", -1))
const _hoisted_164 = {
  key: 1,
  class: "ones"
}
const _hoisted_165 = ["src"]
const _hoisted_166 = { class: "name" }
const _hoisted_167 = {
  key: 0,
  class: "names"
}
const _hoisted_168 = { key: 0 }
const _hoisted_169 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_170 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_171 = { class: "vips" }
const _hoisted_172 = ["src"]
const _hoisted_173 = {
  key: 0,
  class: "novip"
}
const _hoisted_174 = { class: "money" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_176 = { key: 0 }
const _hoisted_177 = { key: 1 }
const _hoisted_178 = { class: "work" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "作品", -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upright" }, null, -1))
const _hoisted_181 = { class: "guanzhu" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "关注", -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upright" }, null, -1))
const _hoisted_184 = { class: "fans" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "粉丝", -1))
const _hoisted_186 = { class: "list" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的订单")
], -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "作品中心")
], -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的账户")
], -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的收藏")
], -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "我的足迹")
], -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "新手指南")
], -1))
const _hoisted_193 = { class: "share" }
const _hoisted_194 = { class: "container" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "工业自动化设计方案共享平台"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  })
], -1))
const _hoisted_196 = { class: "tab" }
const _hoisted_197 = { class: "container container-share" }
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "h1" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "hone" }, "收录"),
      /*#__PURE__*/_createElementVNode("h1", null, "真实设计方案")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " 我们将自动化、机器人领域经过多年迭代、运用的成熟设计资料,通过精细的整合、分类标准后以资料包的 形式呈现于平台之上,供设计者、爱好者、学习者下载使用或学习参考。 "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_13,
      alt: "",
      class: "arrow"
    })
  ])
], -1))
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_14,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "h1" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "hone" }, "内容详尽,"),
      /*#__PURE__*/_createElementVNode("h1", null, "即下即用")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " 每套设计方案内容齐全、完整,包含最为详尽的设计建模、加工图纸、BOM、应用 指导、演示视频等,保证每一个文件的可信、可靠、即下即用 "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_13,
      alt: "",
      class: "arrow"
    })
  ])
], -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_15,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "h1" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "hone" }, "自动化"),
      /*#__PURE__*/_createElementVNode("h1", null, "设计创收平台")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " 我们通过上传、分享、合作签约的形式,将分散于个人、企业内的设计资料通过严格细致的审核与整合,呈现于平台内,内容上传者可获得一定收益。以知识共享的力量拉近全行业内设计者之间的距离,实现知识与经验的高效复用和迭代,加快相关行业整体设计水平的快速提升。 "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_13,
      alt: "",
      class: "arrow"
    })
  ])
], -1))
const _hoisted_201 = /*#__PURE__*/_createStaticVNode("<div class=\"img1\" data-v-71897679><img src=\"" + _imports_16 + "\" alt=\"\" data-v-71897679></div><div data-v-71897679><div class=\"img2\" data-v-71897679><img src=\"" + _imports_17 + "\" alt=\"\" data-v-71897679></div><div class=\"img3\" data-v-71897679><img src=\"" + _imports_18 + "\" alt=\"\" data-v-71897679></div></div>", 2)
const _hoisted_203 = { class: "animation" }
const _hoisted_204 = { class: "container boxs" }
const _hoisted_205 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-71897679><h2 data-v-71897679>机械原理动画</h2><img src=\"" + _imports_11 + "\" alt=\"\" data-v-71897679></div><div class=\"left\" data-v-71897679><div data-v-71897679><div class=\"content\" data-v-71897679><p class=\"number\" data-v-71897679>01</p><p class=\"text\" data-v-71897679>应用场景真实呈现</p></div><div class=\"content\" data-v-71897679><p class=\"number\" data-v-71897679>02</p><p class=\"text\" data-v-71897679>设纪元独家制作</p></div><div class=\"content\" data-v-71897679><p class=\"number\" data-v-71897679>03</p><p class=\"text\" data-v-71897679>相关设计方案一键触达</p></div><div class=\"content\" data-v-71897679><p class=\"number\" data-v-71897679>04</p><p class=\"text\" data-v-71897679>动画原理详细解析</p></div></div></div>", 2)
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_19,
    alt: ""
  })
], -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_20,
    alt: ""
  })
], -1))
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_21,
    alt: ""
  })
], -1))
const _hoisted_211 = { class: "learn" }
const _hoisted_212 = { class: "container boxs" }
const _hoisted_213 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-71897679><h2 data-v-71897679>工业自动化方向免费知识学习</h2><img src=\"" + _imports_11 + "\" alt=\"\" data-v-71897679></div><div class=\"content\" data-v-71897679><div class=\"left\" data-v-71897679><div data-v-71897679><h2 data-v-71897679>获得相关经验技术</h2><p data-v-71897679>每份资料都可落地</p><p data-v-71897679>设计原理和创新解决方案分享</p></div><img src=\"" + _imports_22 + "\" alt=\"\" data-v-71897679></div><div class=\"right1\" data-v-71897679><img src=\"" + _imports_23 + "\" alt=\"\" data-v-71897679><div data-v-71897679><h2 data-v-71897679>方便理解机械运作的动画预览</h2><p data-v-71897679>机械运作动画演示</p><p data-v-71897679>便于理解和学习</p></div></div><div class=\"left\" data-v-71897679><div data-v-71897679><h2 data-v-71897679>详细三维/二维图纸免费下载</h2><p data-v-71897679>该板块设计资料均可免费下载</p><p data-v-71897679>图纸数据标注明确便于免费学习</p></div><img src=\"" + _imports_24 + "\" alt=\"\" data-v-71897679></div><div class=\"right2\" data-v-71897679><img src=\"" + _imports_25 + "\" alt=\"\" data-v-71897679><div data-v-71897679><h2 data-v-71897679>产品零件清单</h2><p data-v-71897679>帮助广大从业者和学生</p><p data-v-71897679>从设计角度去分解产品构成</p></div></div></div>", 2)
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_26,
    alt: ""
  })
], -1))
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_27,
    alt: ""
  })
], -1))
const _hoisted_218 = { class: "platform" }
const _hoisted_219 = { class: "container" }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "中国工业机器人行业供应链\"云采购\"平台"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    alt: ""
  })
], -1))
const _hoisted_221 = { class: "img" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "立即选购", -1))
const _hoisted_224 = [
  _hoisted_222,
  _hoisted_223
]
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "立即选购", -1))
const _hoisted_227 = [
  _hoisted_225,
  _hoisted_226
]
const _hoisted_228 = /*#__PURE__*/_createStaticVNode("<div class=\"text\" data-v-71897679><div class=\"left\" data-v-71897679><img src=\"" + _imports_28 + "\" alt=\"\" width=\"62px\" height=\"57px\" data-v-71897679><div data-v-71897679><h2 data-v-71897679>全产业链精品汇聚</h2><p data-v-71897679>提供工业机器人制造所需核心</p><p data-v-71897679>零部件及丰富的工业机器人产品,</p><p data-v-71897679>一键筛选渠道直达。</p></div></div><div class=\"center\" data-v-71897679><img src=\"" + _imports_29 + "\" alt=\"\" width=\"50px\" height=\"60px\" data-v-71897679><div data-v-71897679><h2 data-v-71897679>助力市场竞争</h2><p data-v-71897679>工业自动化逐渐成为工业生产中的主要力量</p><p data-v-71897679>提高了生产效率和数量,我们拥有工业机器人</p><p data-v-71897679>全产业链商品,助力市场升级。</p></div></div><div class=\"right\" data-v-71897679><img src=\"" + _imports_30 + "\" alt=\"\" width=\"53px\" height=\"46px\" data-v-71897679><div data-v-71897679><h2 data-v-71897679>提升生产力</h2><p data-v-71897679>全球的工厂面临劳动力短缺,我们为您</p><p data-v-71897679>提供安全、高效、高性价比的自动化生</p><p data-v-71897679>产解决方案,助力生产升级。</p></div></div></div>", 1)
const _hoisted_229 = { class: "viprecord" }
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", null, "个人认证")
], -1))
const _hoisted_231 = { class: "record" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 个人认证后，您可以上传作品，对您在设纪元的收益进行提现，进一步保护您的账户安全，防止被盗号。 ", -1))
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "routines" }, "去认证", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_html_footer = _resolveComponent("html-footer")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_home_head),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "clickbox",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goSkip && _ctx.goSkip(...args)))
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_carousel, {
            interval: 5000,
            onChange: _ctx.changelist,
            arrow: "never"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
                return _createVNode(_component_el_carousel_item, {
                  key: item,
                  style: {"height":"517px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }, 8, ["onChange"])
        ]),
        (_ctx.arr1 && _ctx.arr1.datas['自动化设计方案'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(["one", { 'one-active': _ctx.state == 0 }])
                }, [
                  _createVNode(_component_router_link, { to: {
								name: 'goods-class',
							} }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[0].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[0].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[1].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[1].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[2].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[2].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[3].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[3].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[4].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[4].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        to: {
										name: 'goods-class',
										params: {
											classid: _ctx.arr1.datas.自动化设计方案[5].id,
										},
									}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.arr1.datas.自动化设计方案[5].names), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "末端执行器",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[0].names), 1),
                                _createElementVNode("div", _hoisted_12, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[0]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[1].names), 1),
                                _createElementVNode("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[1]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[2].names), 1),
                                _createElementVNode("div", _hoisted_16, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[2]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[3].names), 1),
                                _createElementVNode("div", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[3]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[0].son[4].names), 1),
                                _createElementVNode("div", _hoisted_20, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[0].son[4]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[0].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: _ctx.arr1.datas.自动化设计方案[1].names,
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[1].son[0].names), 1),
                                _createElementVNode("div", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[1].son[0]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[1].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[1].son[1].names), 1),
                                _createElementVNode("div", _hoisted_24, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[1].son[1]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[1].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[1].son[2].names), 1),
                                _createElementVNode("div", _hoisted_26, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[1].son[2]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[1].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[1].son[3].names), 1),
                                _createElementVNode("div", _hoisted_28, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[1].son[3]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[1].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[1].son[4].names), 1),
                                _createElementVNode("div", _hoisted_30, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[1].son[4]
														.son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'goods-class',
																params: {
																	classid: _ctx.arr1.datas.自动化设计方案[1].id,
																	attrid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.names), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_tab_pane, { label: "工业机器人" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[0].names), 1),
                              _createElementVNode("div", _hoisted_32, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[1].names), 1),
                              _createElementVNode("div", _hoisted_34, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[2].names), 1),
                              _createElementVNode("div", _hoisted_36, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[3].names), 1),
                              _createElementVNode("div", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[2].son[4].names), 1),
                              _createElementVNode("div", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[2].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[2].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "输送机构",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[0].names), 1),
                              _createElementVNode("div", _hoisted_42, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[1].names), 1),
                              _createElementVNode("div", _hoisted_44, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[2].names), 1),
                              _createElementVNode("div", _hoisted_46, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[3].names), 1),
                              _createElementVNode("div", _hoisted_48, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[4].names), 1),
                              _createElementVNode("div", _hoisted_50, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[3].son[5].names), 1),
                              _createElementVNode("div", _hoisted_52, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[3].son[5].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[3].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "视觉方案",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[0].names), 1),
                              _createElementVNode("div", _hoisted_54, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[1].names), 1),
                              _createElementVNode("div", _hoisted_56, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[2].names), 1),
                              _createElementVNode("div", _hoisted_58, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[3].names), 1),
                              _createElementVNode("div", _hoisted_60, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[4].names), 1),
                              _createElementVNode("div", _hoisted_62, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[4].son[5].names), 1),
                              _createElementVNode("div", _hoisted_64, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[4].son[5].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[4].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "控制柜",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[0].names), 1),
                              _createElementVNode("div", _hoisted_66, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[1].names), 1),
                              _createElementVNode("div", _hoisted_68, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[2].names), 1),
                              _createElementVNode("div", _hoisted_70, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[3].names), 1),
                              _createElementVNode("div", _hoisted_72, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[4].names), 1),
                              _createElementVNode("div", _hoisted_74, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.自动化设计方案[5].son[5].names), 1),
                              _createElementVNode("div", _hoisted_76, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.自动化设计方案[5].son[5].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'goods-class',
															params: {
																classid: _ctx.arr1.datas.自动化设计方案[5].id,
																attrid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([{ 'one-active': _ctx.state == 1 }, "two"])
                }, [
                  _createVNode(_component_router_link, {
                    to: {
								name: 'video',
							},
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_77
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_78, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.机械原理动画, (item, index) => {
                      return (_openBlock(), _createElementBlock("p", null, [
                        _createVNode(_component_router_link, {
                          to: {
										name: 'video',
										params: {
											id: index + 1,
										},
									}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.机械原理动画, (classitem, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createElementVNode("h2", null, _toDisplayString(classitem.name), 1),
                            _createElementVNode("div", _hoisted_81, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classitem.son, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: item.id
                                }, [
                                  _createVNode(_component_router_link, {
                                    to: {
														name: 'video-class',
														params: {
															cid: classitem.cid,
															aid: item.aid,
														},
													}
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["three", { 'one-active': _ctx.state == 2 }])
                }, [
                  _createVNode(_component_router_link, { to: {
								name: 'free',
							} }, {
                    default: _withCtx(() => [
                      _hoisted_82,
                      _hoisted_83
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_84, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区, (item, index) => {
                      return (_openBlock(), _createElementBlock("p", null, [
                        _createVNode(_component_router_link, {
                          to: {
											name: 'free',
											params: {
												cid: item.id,
											},
										}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tab_pane, {
                          label: "自动化机构案例",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_86, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[0].name), 1),
                                _createElementVNode("div", _hoisted_87, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[0].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[1].name), 1),
                                _createElementVNode("div", _hoisted_89, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[1].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[2].name), 1),
                                _createElementVNode("div", _hoisted_91, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[2].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[0].son[3].name), 1),
                                _createElementVNode("div", _hoisted_93, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[0].son[3].son1, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                      key: item.id
                                    }, [
                                      _createVNode(_component_router_link, {
                                        to: {
																name: 'free',
																params: {
																	cid: _ctx.arr1.datas.免费专区[0].id,
																	aid: item.id,
																},
															}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["to"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "机械手",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[0].name), 1),
                              _createElementVNode("div", _hoisted_95, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[1].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[1].name), 1),
                              _createElementVNode("div", _hoisted_97, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[1].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[2].name), 1),
                              _createElementVNode("div", _hoisted_99, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[1].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[3].name), 1),
                              _createElementVNode("div", _hoisted_101, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[1].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[4].name), 1),
                              _createElementVNode("div", _hoisted_103, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[1].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[1].son[5].name), 1),
                              _createElementVNode("div", _hoisted_105, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[1].son[5].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[1].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, { label: "输送类" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[0].name), 1),
                              _createElementVNode("div", _hoisted_107, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[2].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_108, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[1].name), 1),
                              _createElementVNode("div", _hoisted_109, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[2].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[2].name), 1),
                              _createElementVNode("div", _hoisted_111, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[2].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_112, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[3].name), 1),
                              _createElementVNode("div", _hoisted_113, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[2].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[2].son[4].name), 1),
                              _createElementVNode("div", _hoisted_115, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[2].son[4].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[2].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "提升移载类",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_116, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[3].son[0].name), 1),
                              _createElementVNode("div", _hoisted_117, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[3].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[3].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[3].son[1].name), 1),
                              _createElementVNode("div", _hoisted_119, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[3].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[3].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[3].son[2].name), 1),
                              _createElementVNode("div", _hoisted_121, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[3].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[3].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_122, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[3].son[3].name), 1),
                              _createElementVNode("div", _hoisted_123, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[3].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[3].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "非标设备",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_124, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[4].son[0].name), 1),
                              _createElementVNode("div", _hoisted_125, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[4].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[4].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_126, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[4].son[1].name), 1),
                              _createElementVNode("div", _hoisted_127, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[4].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[4].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[4].son[2].name), 1),
                              _createElementVNode("div", _hoisted_129, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[4].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[4].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "自动化单元",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_130, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[0].name), 1),
                              _createElementVNode("div", _hoisted_131, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_132, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[1].name), 1),
                              _createElementVNode("div", _hoisted_133, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_134, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[2].name), 1),
                              _createElementVNode("div", _hoisted_135, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_136, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[5].son[3].name), 1),
                              _createElementVNode("div", _hoisted_137, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[5].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[5].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_tab_pane, {
                          label: "末端执行器",
                          class: "title"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_138, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[0].name), 1),
                              _createElementVNode("div", _hoisted_139, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[0].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_140, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[1].name), 1),
                              _createElementVNode("div", _hoisted_141, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[1].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[2].name), 1),
                              _createElementVNode("div", _hoisted_143, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[2].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("h2", null, _toDisplayString(_ctx.arr1.datas.免费专区[6].son[3].name), 1),
                              _createElementVNode("div", _hoisted_145, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr1.datas.免费专区[6].son[3].son1, (item) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: item.id
                                  }, [
                                    _createVNode(_component_router_link, {
                                      to: {
															name: 'free',
															params: {
																cid: _ctx.arr1.datas.免费专区[6].id,
																aid: item.id,
															},
														}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["four", { 'one-active': _ctx.state == 3 }])
                }, [
                  _createElementVNode("h3", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoMovibot('')))
                  }, "工业自动化设备供应链"),
                  _createElementVNode("div", {
                    class: "second",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.gotoMovibot('')))
                  }, _hoisted_152),
                  _createElementVNode("div", _hoisted_153, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.tabPosition,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tabPosition) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_tabs, {
                      "tab-position": _ctx.tabPosition,
                      style: {"height":"488px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movibotClass[0].list, (movibot, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_154, [
                            _createElementVNode("h2", {
                              onClick: ($event: any) => (_ctx.gotoMovibot(movibot.url))
                            }, _toDisplayString(movibot.name), 9, _hoisted_155),
                            _createElementVNode("div", _hoisted_156, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movibot.list, (item) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  onClick: ($event: any) => (_ctx.gotoMovibot(item.url))
                                }, _toDisplayString(item.name), 9, _hoisted_157))
                              }), 256))
                            ])
                          ]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["tab-position"])
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_158, [
                (_ctx.showName == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                      _hoisted_160,
                      _hoisted_161,
                      _createVNode(_component_router_link, { to: "/login" }, {
                        default: _withCtx(() => [
                          _hoisted_162
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: "/register" }, {
                        default: _withCtx(() => [
                          _hoisted_163
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                      _createVNode(_component_router_link, { to: "user" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.getImgUrl(_ctx.userInfo.portrait),
                            alt: "",
                            class: "photo"
                          }, null, 8, _hoisted_165)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_166, [
                        (_ctx.userInfor.datas.identification)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                              _createVNode(_component_router_link, { to: "user" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.userInfor.datas.username), 1),
                                  (
											_ctx.userInfor.datas.username == null ||
											_ctx.userInfor.datas.username == ''
										)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_168, _toDisplayString(_ctx.userInfor.datas.mobile), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              (
										_ctx.userInfor.datas.identification == 3 &&
										_ctx.userInfor.datas.company_id == null
									)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_169))
                                : _createCommentVNode("", true),
                              (_ctx.userInfor.datas.company_id != null)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_170))
                                : _createCommentVNode("", true),
                              (
										_ctx.userInfor.datas.company_id == null &&
										_ctx.userInfor.datas.identification != 3
									)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 2,
                                    src: _imports_3,
                                    alt: "",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDialogVisibles())),
                                    style: {"cursor":"pointer"}
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_router_link, { to: "user/myvip" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_171, [
                            (_ctx.vipInfor.data.homeimgurl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.vipInfor.data.homeimgurl,
                                  alt: "",
                                  class: "vip"
                                }, null, 8, _hoisted_172))
                              : _createCommentVNode("", true),
                            (_ctx.isVip)
                              ? (_openBlock(), _createElementBlock("p", {
                                  key: 1,
                                  class: "vip-title",
                                  style: _normalizeStyle([{"text-align":"center","margin":"10px 0"}, { color: _ctx.vipInfor.data.homecolor }])
                                }, _toDisplayString(_ctx.userInfo.vipInfo.vipTitle), 5))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.isVip)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_173, "开通会员全场商品八折优惠"))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: "user/myaccount" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_174, [
                            _hoisted_175,
                            (_ctx.userInfor.datas.pid == 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_176, _toDisplayString(_ctx.a + Number(_ctx.userInfor.datas.gear)), 1))
                              : _createCommentVNode("", true),
                            (_ctx.userInfor.datas.pid != 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_177, _toDisplayString(_ctx.a + Number(_ctx.fatherInformation.datas.gear)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", {
                        class: "number",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goUser && _ctx.goUser(...args)))
                      }, [
                        _createElementVNode("div", _hoisted_178, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.fansInfor.datas.works), 1),
                          _hoisted_179
                        ]),
                        _hoisted_180,
                        _createElementVNode("div", _hoisted_181, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.fansInfor.datas.follows), 1),
                          _hoisted_182
                        ]),
                        _hoisted_183,
                        _createElementVNode("div", _hoisted_184, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.userInfor.datas.fans), 1),
                          _hoisted_185
                        ])
                      ]),
                      _createElementVNode("button", {
                        class: "routine",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.loginOut && _ctx.loginOut(...args)))
                      }, "退出登录")
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_186, [
                  _createVNode(_component_router_link, { to: "/user/myorder" }, {
                    default: _withCtx(() => [
                      _hoisted_187
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/works" }, {
                    default: _withCtx(() => [
                      _hoisted_188
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/myaccount" }, {
                    default: _withCtx(() => [
                      _hoisted_189
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/project" }, {
                    default: _withCtx(() => [
                      _hoisted_190
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: "/user/myfootmark" }, {
                    default: _withCtx(() => [
                      _hoisted_191
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'guidance' } }, {
                    default: _withCtx(() => [
                      _hoisted_192
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_193, [
        _createElementVNode("div", _hoisted_194, [
          _hoisted_195,
          _createElementVNode("div", _hoisted_196, [
            _createVNode(_component_el_tabs, {
              modelValue: _ctx.activeName,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.activeName) = $event)),
              onTabClick: _ctx.handleClick,
              stretch: false,
              style: {"color":"white","height":"300px","width":"100%","caret-color":"transparent"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "收录真实设计方案",
                  name: "first"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "内容详尽 即下即用",
                  name: "second"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "自动化设计创收平台",
                  name: "third"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onTabClick"])
          ]),
          _createElementVNode("div", _hoisted_197, [
            _createVNode(_component_el_carousel, {
              ref: "carouselshare",
              interval: 4000,
              type: "card",
              autoplay: false,
              arrow: "never",
              "initial-index": "1",
              "indicator-position": "none",
              onChange: _ctx.shareChange,
              height: "518px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_carousel_item, {
                  class: _normalizeClass({
								'el-carousel-item-box1': _ctx.activeName == 'second',
								'el-carousel-item-box2': _ctx.activeName == 'third',
							})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: {
									name: 'goods-class',
								},
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_198
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_el_carousel_item, {
                  class: _normalizeClass({
								'el-carousel-item-box1': _ctx.activeName == 'third',
								'el-carousel-item-box2': _ctx.activeName == 'first',
							})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: {
									name: 'goods-class',
								},
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_199
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_el_carousel_item, {
                  class: _normalizeClass({
								'el-carousel-item-box1': _ctx.activeName == 'first',
								'el-carousel-item-box2': _ctx.activeName == 'second',
							})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/user/works",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_200
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }, 8, ["onChange"])
          ]),
          _hoisted_201
        ])
      ]),
      _createElementVNode("div", _hoisted_203, [
        _createElementVNode("div", _hoisted_204, [
          _hoisted_205,
          _createVNode(_component_router_link, {
            to: {
						name: 'video',
					},
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_207,
              _hoisted_208
            ]),
            _: 1
          }),
          _hoisted_209,
          _hoisted_210
        ])
      ]),
      _createElementVNode("div", _hoisted_211, [
        _createElementVNode("div", _hoisted_212, [
          _hoisted_213,
          _createVNode(_component_router_link, {
            to: {
						name: 'free',
					},
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _hoisted_215
            ]),
            _: 1
          }),
          _hoisted_216,
          _hoisted_217
        ])
      ]),
      _createElementVNode("div", _hoisted_218, [
        _createElementVNode("div", _hoisted_219, [
          _hoisted_220,
          _createElementVNode("div", _hoisted_221, [
            _createElementVNode("div", {
              class: "img1",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (
							_ctx.gotoMovibots(
								'https://shop7672203n1v711.1688.com/?spm=a262cb.19918180.kx9yz0hj.2.27661a81lpEXy7'
							)
						)),
              role: "link"
            }, _hoisted_224),
            _createElementVNode("div", {
              class: "img2",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.gotoMovibots('https://www.movibot-art.com/')))
            }, _hoisted_227)
          ]),
          _hoisted_228
        ])
      ]),
      _createVNode(_component_html_footer)
    ]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRefs",
      dialogwidth: "580px",
      class: "tongzhi"
    }, {
      header: _withCtx(() => []),
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_229, [
          _hoisted_230,
          _createElementVNode("div", _hoisted_231, [
            _hoisted_232,
            _createElementVNode("button", {
              class: "routine",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.mcloses()))
            }, "取消"),
            _createVNode(_component_router_link, { to: "user/selfverify" }, {
              default: _withCtx(() => [
                _hoisted_233
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}